import { snakeCase as lodashSnakeCase } from 'lodash';

export const ISSUE_ATTRIBUTE_NAMES = {
  TITLE: 'title',
  CUSTOM_IDENTIFIER: 'customIdentifier',
  DESCRIPTION: 'description',
  SUGGESTED_ANSWER: 'suggestedAnswer',
  STATUS: 'status',
  ASSIGNED_TO: 'assignedTo',
  ASSIGNED_TO_TYPE: 'assignedToType',
  DUE_DATE: 'dueDate',
  LOCATION_DESCRIPTION: 'locationDescription',
  TRANSITION_ID: 'transitionId',
  ANSWER: 'answer',
  OFFICIAL_RESPONSE: 'officialResponse', //v2 name of answer
  COMMENTS_ATTRIBUTES: 'commentsAttributes',
  ATTACHMENTS_ATTRIBUTES: 'attachmentsAttributes',
  TARGET_URN: 'targetUrn',
  LINKED_DOCUMENT: 'linked_document', // the new name of targetUrn in V2
  CLOSE_VERSION: 'closeVersion',
  LINKED_DOCUMENT_CLOSE_VERSION: 'linkedDocumentCloseVersion',
  CO_REVIEWERS: 'coReviewers',
  DISTRIBUTION_LIST: 'distributionList',
  ATTACHMENT: 'attachment',
  COMMENT: 'body',
  DELETED_AT: 'deletedAt',
  PUSHPIN_ATTRIBUTES: 'pushpinAttributes',
  HIDDEN_DOC_VERSION: 'hiddenDocVersion',
  SPEC_SECTION: 'specSection',
  COST: 'costImpact',
  SCHEDULE: 'scheduleImpact',
  PRIORITY: 'priority',
  DISCIPLINE: 'discipline',
  CATEGORY: 'category',
  SUB_ID: 'reference',
  QUESTION: 'question',
  LOCATION: 'location',
  LINK_PCO: 'pcoLink',
};

export const ISSUE_ATTRIBUTE_NAMES_MAP = {
  [ISSUE_ATTRIBUTE_NAMES.OFFICIAL_RESPONSE]: ISSUE_ATTRIBUTE_NAMES.ANSWER,
};
export const ISSUE_ATTRIBUTE_GROUPS = [
  {
    name: 'MAIN_DETAILS',
    attributes: [
      ISSUE_ATTRIBUTE_NAMES.STATUS, ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER, ISSUE_ATTRIBUTE_NAMES.TITLE, ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
      ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS, ISSUE_ATTRIBUTE_NAMES.DUE_DATE,
    ],
  },
  {
    name: 'QUESTION',
    attributes: [ISSUE_ATTRIBUTE_NAMES.DESCRIPTION, ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER, ISSUE_ATTRIBUTE_NAMES.ATTACHMENTS_ATTRIBUTES],
  },
  {
    name: 'REFERENCES',
    attributes: [ISSUE_ATTRIBUTE_NAMES.TARGET_URN, ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION],
  },
  {
    name: 'IMPACT',
    attributes: [ISSUE_ATTRIBUTE_NAMES.COST, ISSUE_ATTRIBUTE_NAMES.SCHEDULE],
  },
  {
    name: 'OTHER_ATTRIBUTES',
    attributes: [ISSUE_ATTRIBUTE_NAMES.PRIORITY, ISSUE_ATTRIBUTE_NAMES.DISCIPLINE, ISSUE_ATTRIBUTE_NAMES.CATEGORY, ISSUE_ATTRIBUTE_NAMES.SUB_ID],
  },
  {
    name: 'DISTRIBUTION',
    attributes: [ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST],
  },
];

export const ISSUE_ATTRIBUTE_GROUPS_ENTITY_LINKER = [
  {
    name: 'MAIN_DETAILS',
    attributes: [
      ISSUE_ATTRIBUTE_NAMES.STATUS,
      ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER,
      ISSUE_ATTRIBUTE_NAMES.TITLE,
      ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
      ISSUE_ATTRIBUTE_NAMES.DUE_DATE,
    ],
  },
  {
    name: 'QUESTION',
    attributes: [
      ISSUE_ATTRIBUTE_NAMES.DESCRIPTION, // Question
      ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER,
      ISSUE_ATTRIBUTE_NAMES.ATTACHMENTS_ATTRIBUTES,
    ],
  },
  {
    name: 'REFERENCES',
    attributes: [ISSUE_ATTRIBUTE_NAMES.TARGET_URN, ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION],
  },
  {
    name: 'OTHER_ATTRIBUTES',
    attributes: [ISSUE_ATTRIBUTE_NAMES.PRIORITY],
  },
];

export const ISSUE_BE_ATTRIBUTE_NAMES = {
};
export const FORM_CONFIG_NAMES = {
  CLASSIC: 'CLASSIC',
  ENTITY_LINKER: 'ENTITY_LINKER',
};

export const FORM_CONFIG = {
  [FORM_CONFIG_NAMES.CLASSIC]: ISSUE_ATTRIBUTE_GROUPS,
  [FORM_CONFIG_NAMES.ENTITY_LINKER]: ISSUE_ATTRIBUTE_GROUPS_ENTITY_LINKER,
};

Object.keys(ISSUE_ATTRIBUTE_NAMES).forEach(key => { ISSUE_BE_ATTRIBUTE_NAMES[ISSUE_ATTRIBUTE_NAMES[key]] = lodashSnakeCase(ISSUE_ATTRIBUTE_NAMES[key]); });
